<template>
  <div id="main-container-feestructure-block">
    <div class="block-title">
      <div class="title">Required documents</div>
    </div>
    <div class="block-description">
      <h1>For higher education</h1>

      <ul>
        <li><strong>Passport</strong></li>
        <li><strong>Notarized translation of the passport</strong></li>
        <li><strong>Education document</strong></li>
        <li><strong>Translation of the education document</strong></li>
        <li><strong>Migration card</strong></li>
        <li><strong>Visa</strong></li>
        <li><strong>Consent for enrollment</strong></li>
        <li><strong>2 photographs (3x4 cm)</strong></li>
      </ul>

      <p>
        An entrance examination is provided - 3 subjects depending on the chosen
        direction.
      </p>

      <div class="section">
        <h1>For additional professional education in Russian:</h1>
        <ul>
          <li>
            <strong>Passport.</strong> The validity period of the identity
            document of a foreign citizen on the day of entry into the Russian
            Federation must be at least 18 (eighteen) months.
          </li>
          <li><strong>Notarized translation of the passport.</strong></li>
          <li>
            <strong>A foreign state document on education</strong> with
            legalization in the manner established by the legislation of the
            Russian Federation or with an apostille (except for cases when, in
            accordance with the legislation of the Russian Federation and (or)
            an international treaty, legalization or apostille is not required).
          </li>
          <li>
            <strong>A translation of the educational document,</strong>
            certified by a notary.
          </li>
          <li>Fill out the applicant's application form.</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { datatexten } from "@/data/datatext.js";
// import { datatextfr } from "@/data/datatextfr.js";
// import { datatextab } from "@/data/datatextab.js";
export default {
  data() {
    return { container: {} };
  },
  created() {
    if (this.$route.name == "EnVersion") {
      this.container = datatexten.feeStructureBlock;
    }
    //     if (this.$route.name == "FrVersion") {
    //       this.container = datatextfr.feeStructureBlock;
    //     }
    //     if (this.$route.name == "AbVersion") {
    //       this.container = datatextab.feeStructureBlock;
    //     }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.block-title {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #dbefff;

  .title {
    font-weight: 700;
    font-size: 52px;
    line-height: 1.23;
    box-sizing: content-box;
    max-width: 1200px;
    text-align: center;
    margin: 0 auto;
  }
}
.block-description {
  max-width: 1200px;
  display: table;
  margin: 0 auto;
  padding: 30px 20px;
  font-size: 16px;
  line-height: 25px;
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
  margin: 0 auto;
  opacity: 0.9;
  padding-bottom: 20px;
  font-weight: 300;
}
.light-text {
  font-weight: 300;
}
a {
  color: black;
}

h1 {
  padding-bottom: 5px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin-bottom: 10px;
  padding-left: 20px;
  text-indent: -20px;
}
li:before {
  content: "• ";
  color: #1a237e;
  font-weight: bold;
}
.note {
  background-color: #f5f5f5;
  padding: 15px;
  border-left: 4px solid #ff6f00;
  margin-top: 20px;
  font-style: italic;
}
.section {
  margin-top: 30px;
}
</style>
